var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83,
    height: 37,
    viewBox: "0 0 83 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1921",
    "data-name": "Rectangle 1921",
    width: 83,
    height: 37,
    transform: "translate(377.548 288.933)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1632",
    "data-name": "Mask Group 1632",
    transform: "translate(-377.548 -288.933)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa_1_",
    "data-name": "visa (1)",
    transform: "translate(379.827 295.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10316",
    "data-name": "Path 10316",
    d: "M61.6,82.68l4.008-22.547h6.263L67.988,82.68Z",
    transform: "translate(-32.665 -59.382)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10317",
    "data-name": "Path 10317",
    d: "M61.6,82.68l5.136-22.547h5.136L67.988,82.68Z",
    transform: "translate(-32.665 -59.382)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10318",
    "data-name": "Path 10318",
    d: "M101.831,59.535a15.887,15.887,0,0,0-5.762-1c-6.263,0-10.772,3.131-10.772,7.641,0,3.382,3.131,5.136,5.637,6.263s3.257,1.879,3.257,2.881c0,1.5-2,2.255-3.758,2.255A13.615,13.615,0,0,1,84.42,76.32l-.877-.376-.877,5.136a20.31,20.31,0,0,0,7.14,1.253c6.639,0,11.023-3.131,11.023-7.891,0-2.63-1.628-4.635-5.386-6.263-2.255-1.127-3.632-1.754-3.632-2.881,0-1,1.127-2,3.632-2a11.489,11.489,0,0,1,4.76.877l.626.251,1-4.885Z",
    transform: "translate(-43.837 -58.533)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M101.831,59.535a15.887,15.887,0,0,0-5.762-1c-6.263,0-9.645,3.131-9.645,7.641,0,3.382,2,5.136,4.509,6.263s3.257,1.879,3.257,2.881c0,1.5-2,2.255-3.758,2.255A13.615,13.615,0,0,1,84.42,76.32l-.877-.376-.877,5.136a20.31,20.31,0,0,0,7.14,1.253c6.639,0,11.023-3.131,11.023-7.891,0-2.63-1.628-4.635-5.386-6.263-2.255-1.127-3.632-1.754-3.632-2.881,0-1,1.127-2,3.632-2a11.489,11.489,0,0,1,4.76.877l.626.251,1-4.885Z",
    transform: "translate(-43.837 -58.533)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M132.118,60.133c-1.5,0-2.63.125-3.257,1.628L119.467,82.68h6.764l1.253-3.758H135.5l.752,3.758h6.012L137,60.133Zm-2.881,15.031c.376-1.127,2.505-6.639,2.505-6.639s.5-1.378.877-2.255l.376,2.129s1.253,5.637,1.5,6.889h-5.261Z",
    transform: "translate(-63.351 -59.382)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M133.621,60.133c-1.5,0-2.63.125-3.257,1.628l-10.9,20.918h6.764l1.253-3.758H135.5l.752,3.758h6.012L137,60.133Zm-4.384,15.031c.5-1.253,2.505-6.639,2.505-6.639s.5-1.378.877-2.255l.376,2.129s1.253,5.637,1.5,6.889h-5.261Z",
    transform: "translate(-63.351 -59.382)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10322",
    "data-name": "Path 10322",
    d: "M26.461,76.057,25.835,72.8c-1.127-3.758-4.76-7.891-8.768-9.9L22.7,82.947h6.764L39.613,60.4H32.849Z",
    transform: "translate(-9.05 -59.523)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10323",
    "data-name": "Path 10323",
    d: "M26.461,76.057,25.835,72.8c-1.127-3.758-4.76-7.891-8.768-9.9L22.7,82.947h6.764L39.613,60.4H34.1Z",
    transform: "translate(-9.05 -59.523)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10324",
    "data-name": "Path 10324",
    d: "M0,60.133l1.127.251c8.017,1.879,13.528,6.639,15.657,12.275L14.53,62.012c-.376-1.5-1.5-1.879-2.881-1.879Z",
    transform: "translate(0 -59.382)",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10325",
    "data-name": "Path 10325",
    d: "M0,60.133H0c8.017,1.879,14.655,6.764,16.785,12.4l-2.129-8.893a3.058,3.058,0,0,0-3.006-2.38Z",
    transform: "translate(0 -59.382)",
    fill: "#f7981d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10326",
    "data-name": "Path 10326",
    d: "M0,60.133H0c8.017,1.879,14.655,6.764,16.785,12.4l-1.5-4.885c-.376-1.5-.877-3.006-2.63-3.632Z",
    transform: "translate(0 -59.382)",
    fill: "#ed7c00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    transform: "translate(8.142 3.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10327",
    "data-name": "Path 10327",
    d: "M32.865,77.993l-4.259-4.259-2,4.76-.5-3.131c-1.127-3.758-4.76-7.891-8.768-9.9L22.97,85.508h6.764Z",
    transform: "translate(-17.333 -65.467)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10328",
    "data-name": "Path 10328",
    d: "M67.988,101.911,62.6,96.4l-1,5.511Z",
    transform: "translate(-40.807 -81.87)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10329",
    "data-name": "Path 10329",
    d: "M93.564,91.6h0c.5.5.752.877.626,1.378,0,1.5-2,2.255-3.758,2.255A13.615,13.615,0,0,1,84.42,93.98l-.877-.376-.877,5.136a20.31,20.31,0,0,0,7.14,1.253c4.008,0,7.265-1.127,9.144-3.131Z",
    transform: "translate(-51.978 -79.325)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10330",
    "data-name": "Path 10330",
    d: "M121.333,89.609h5.887l1.253-3.758h8.017l.752,3.758h6.012l-2.129-9.144L133.609,73.2l.376,2s1.253,5.637,1.5,6.889h-5.261c.5-1.253,2.505-6.639,2.505-6.639s.5-1.378.877-2.255",
    transform: "translate(-72.483 -69.568)",
    fill: "#051244"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9d81626455a9674c0aa41ea37d0627a0.svg";
export { ForwardRef as ReactComponent };